import { Box, Paper } from '@mui/material'
import type { ReactNode } from 'react'

import SectionHeader from '@/features/bidding/components/cascading/bid-ladder/shared/SectionHeader'

type ChartSectionProps = {
  /** Section title displayed in the header */
  title: string
  /** Section subtitle displayed in the header */
  subtitle: string
  /** Minimum height for the content area */
  minHeight: number
  /** Background color for the content area (defaults to 'background.paper') */
  contentBackgroundColor?: string
  /** Whether to show a bottom border (defaults to true) */
  showBorderBottom?: boolean
  /** Optional action element rendered in the header (e.g. expand button) */
  action?: ReactNode
  /** Chart or content to display */
  children: ReactNode
}

function ChartSection({
  title,
  subtitle,
  minHeight,
  contentBackgroundColor = 'background.paper',
  showBorderBottom = true,
  action,
  children,
}: Readonly<ChartSectionProps>) {
  return (
    <Paper
      elevation={0}
      sx={{
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 0,
        ...(showBorderBottom && {
          borderBottom: '1px solid',
          borderColor: 'divider',
        }),
        backgroundColor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      <SectionHeader action={action} subtitle={subtitle} title={title} />
      <Box
        sx={{
          minHeight,
          backgroundColor: contentBackgroundColor,
        }}
      >
        {children}
      </Box>
    </Paper>
  )
}

export default ChartSection
